import React from "react";
import { observer } from "mobx-react";
import { withRouter, NavLink, useRouteMatch, useLocation } from "react-router-dom";
import Button from "./Button";
import { editAccountNotesState } from "Pages/Dashboard/Accounts/Notes/Main";

const TabNavigation = observer((props = {}) => {
  const routeMatch = useRouteMatch();
  const location = useLocation();
  const { tabList = [], className = "" } = props || {};

  // Get base URL from route match, or fallback to location pathname
  // This prevents navigation to "/reports-v2/undefined" when route match fails
  let baseUrl = routeMatch?.url;
  if (!baseUrl) {
    // Extract base path from current location (e.g., "/reports-v2" from "/reports-v2/activity")
    const pathParts = location.pathname.split('/').filter(Boolean);
    if (pathParts.length > 0) {
      baseUrl = `/${pathParts[0]}`;
    } else {
      baseUrl = location.pathname;
    }
  }

  const addNotesFn = () => {
    editAccountNotesState.setShowEdit(true);
    editAccountNotesState.setIsAddBtn(true);
    editAccountNotesState.setIsEdit(false);
  };

  const addNotes = {
    id: "addAccountNotes",
    name: "addAccountNotes",
    btnText: "Add Notes",
    type: "button",
    className: "addAccountNotesBtn",
    click: addNotesFn
  };

  return (
    <div className={`tabNavigationBody ${className}`}>
      {(tabList?.length && (
        <ul className="tabNavigation">
          {tabList.map(item => {
            const { id = "", path = "", name = "" } = item || {};
            // Only render NavLink if we have a valid baseUrl and path
            if (!baseUrl || !path) {
              return null;
            }
            return (
              <NavLink
                className={`tabItem`}
                activeClassName="active"
                id={id}
                key={id}
                to={`${baseUrl}/${path}`}
              >
                {name}
              </NavLink>
            );
          })}
        </ul>
      )) ||
        ""}
      {!editAccountNotesState?.isAddBtn &&
        editAccountNotesState?.notesNewUser && (
          <div className="addNotesButton">
            <Button {...addNotes} />
          </div>
        )}
    </div>
  );
});

export default withRouter(TabNavigation);
export { TabNavigation };
